import NzRollReturnsAdapter from './base';

export default class RollReturn extends NzRollReturnsAdapter {
  modelNamePlural = 'rollReturns';
}
